import React from "react";
import Image from "../elements/Image";
import Input from "../form/Input";
import Button from "../form/Button";
import { useSelector } from "react-redux";

const CheckApplicationStatus = ({ setAppStatus }) => {
  const { siteSetting } = useSelector((state) => state.setting);

  return (
    <>
      <div className="space-y-10">
        <div className="h-20 mx-auto flex justify-center">
          {siteSetting?.logo?.url ? (
            <Image src={siteSetting?.logo?.url} alt="" effect={"blur"} classes={"object-contain"} />
          ) : (
            <div className="w-32 h-12 bg-gray-300 animate-pulse" />
          )}
        </div>
        <div className="space-y-6">
          <div className="font-Gotham font-medium text-center">Enter details or Log in to check status.</div>
          <div className="flex items-end gap-2 max-w-xl mx-auto">
            <div className="relative flex-shrink flex-grow">
              <Input
                label={"Enter Email/Last Name"}
                labelClasses={"mb-2 !text-gable-green"}
                inputClasses={
                  "!bg-transparent !rounded-full border-hobby !h-12 font-Gotham placeholder:!text-hobby placeholder:!italic"
                }
                inputPlaceholder={"Enter Email/Last Name"}
              />
            </div>
            <div className="relative flex-shrink flex-grow">
              <Input
                label={"Enter Application #"}
                labelClasses={"mb-2 !text-gable-green"}
                inputClasses={
                  "!bg-transparent !rounded-full border-hobby !h-12 font-Gotham placeholder:!text-hobby placeholder:!italic"
                }
                inputPlaceholder={"Application Reference #"}
                inputType={"number"}
              />
            </div>
            <div className="relative flex-shrink-0">
              <Button buttonLabel={"Submit"} buttonClasses={"!h-12 !rounded-full !px-6"} />
            </div>
          </div>
        </div>
        <div className="border-t border-shades-04 h-px flex items-center justify-center">
          <span className="inline-flex items-center justify-center w-10 aspect-square bg-white pb-1 font-Gotham text-shades-05">
            or
          </span>
        </div>
        <div className="flex flex-col items-center justify-center">
          <Button
            buttonHasLink={true}
            buttonLink={"/authentication"}
            buttonFunction={() => setAppStatus(false)}
            buttonLabel={"Sign In"}
            buttonClasses={"!h-14 !rounded-full !px-10"}
            buttonLabelClasses={"!text-base sm:!text-lg"}
          />
          <Button
            buttonHasLink={true}
            buttonLink={"/contact"}
            buttonFunction={() => setAppStatus(false)}
            buttonLabel={"Need Help?"}
            buttonClasses={"!h-14 !bg-transparent !px-0 !text-gable-green"}
          />
        </div>
      </div>
    </>
  );
};

export default CheckApplicationStatus;
